import * as React from 'react'

import { useTranslation } from 'react-i18next'

import { Text } from '@chakra-ui/react'

import {
  ModalView,
  PrimaryButton,
  TertiaryButton,
  toaster,
} from '@enechain/ecloud-designsystem'

import { useUnlockAccount } from '~/pages/Members/hooks/useUnlockAccount'

type Props = {
  memberId: string
  open: boolean
  onClose: () => void
  onSuccess: () => void
}
const UnlockModal: React.FC<Props> = ({
  memberId,
  open,
  onClose,
  onSuccess,
}) => {
  const { t } = useTranslation()
  const { mutate, isPending, reset } = useUnlockAccount(memberId, onSuccess)
  const onUnlock = (): void => {
    mutate({ memberId })
    toaster.create({
      title: t('pages.members.action.unlock.success'),
      type: 'success',
    })
    onSuccess()
  }

  return (
    <ModalView
      title={t('pages.members.action.unlock.title')}
      open={open}
      onClose={onClose}
      onExitComplete={reset}
      bodyChildren={
        <Text whiteSpace="pre-wrap">
          {t('pages.members.action.unlock.description')}
        </Text>
      }
      footerChildren={
        <>
          <TertiaryButton onClick={onClose}>
            {t('action.cancel')}
          </TertiaryButton>
          <PrimaryButton
            onClick={onUnlock}
            loading={isPending}
            disabled={isPending}
            spinnerPlacement="start"
          >
            {t('pages.members.action.unlock.confirm')}
          </PrimaryButton>
        </>
      }
    />
  )
}

export default React.memo(UnlockModal)
